import {Locales} from '@netx/core-next/locales/utils/Locales';

export const AttributeUploadActionLabel = Locales((i18n) => ({
	DOCUMENTATION: i18n('i18n.documentation'),
	ROUTE: i18n('i18n.importAttributeData'),
	SUBMIT: i18n('i18n.save'),
}));

export const AttributeUploadMessage = Locales((i18n) => ({
	HELP: i18n('i18n.attributeDataImportTroubleshooting'),
	PROCESSING: i18n('i18n.processingAttributeData'),
	PROCESSED: i18n('i18n.importAttributeDataSucceeded'),
	PROCESSING_FAILED: i18n('i18n.importAttributeDataFailed'),
}));

export const AttributeUploadTitle = Locales((i18n) => ({
	IMPORT: i18n('i18n.importAttributeData'),
}));
